module.exports = "<div ng-include=\"'app/modules/trains-base/templates/flights/form_options/trains-cabin-class-dropdown.html'\"></div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/train/directives/templates/moreOptions.tmpl.html
// module id = 3693
// module chunks = 0